var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMobile && _vm.numRooms > 2)?_c('Slider',{attrs:{"selector":".room-tabs__slider","slidesToShow":_vm.numRooms === 3 ? 2 : 3,"slidesToScroll":1,"selectedRoom":_vm.selectedRoom,"responsiveInfinite":false,"dots":false}},[_c('div',{staticClass:"room-tabs rd-view__main-content rhg-m-width rhg-my-0 room-tabs__slider"},_vm._l((_vm.numRooms),function(room){return _c('div',{key:room,ref:_vm.getRoomTabRef(room),refInFor:true,class:[
        'room-tabs__chip',
        { 'room-tabs__chip--active': room === _vm.selectedRoom },
        {
          'room-tabs__chip--disabled': room > _vm.lastRoomSelected
        }
      ],on:{"click":function($event){return _vm.selectRoom(room)}}},[_vm._v(" "+_vm._s(_vm.getRoomLabel(room))+" ")])}),0)]):_c('div',{staticClass:"room-tabs rd-view__main-content rhg-m-width rhg-my-0",class:_vm.isMobile && _vm.numRooms > 2 ? 'room-tabs__spacing-mobile' : 'room-tabs__spacing'},_vm._l((_vm.numRooms),function(room){return _c('div',{key:room,ref:_vm.getRoomTabRef(room),refInFor:true,class:[
      'room-tabs__chip',
      { 'room-tabs__chip--active': room === _vm.selectedRoom },
      {
        'room-tabs__chip--disabled': room > _vm.lastRoomSelected
      }
    ],on:{"click":function($event){return _vm.selectRoom(room)}}},[_vm._v(" "+_vm._s(_vm.getRoomLabel(room))+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }